import React, { Fragment } from 'react';

import HtmlInput from '../html/TextArea';
import InputError from '../errors/InputError';

export default ({
  Input = HtmlInput,
  Error = InputError,
  placeholder = '',
  isHidden,
  autoFocus,
  value,
  onChange,
  isDisabled,
  name = 'text',
  error,
  hasError,
  htmlType,
  column,
  rows,
  ...rest
}) => (
  <Fragment>
    <Input
      id={name}
      type={isHidden ? 'hidden' : htmlType ? htmlType : 'text'}
      name={name}
      autoComplete="on"
      autoCapitalize="off"
      autoCorrect="off"
      placeholder={placeholder}
      autoFocus={autoFocus || false}
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      disabled={isDisabled}
      hasError={hasError}
      column={column}
      rows={rows}
      {...rest}
    />
    <Error isVisible={hasError} id={name}>
      {hasError ? error : ''}
    </Error>
  </Fragment>
);
